import React, { useState, useRef, useEffect } from "react";
import bannerImage from "../assets/bannerFamiliaApoyo.png";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import "./BannerWithName.css";

const BannerWithName = () => {

  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  const [hasDownloaded, setHasDownloaded] = useState(false);

  const bannerRef = useRef(null);

  // cargar datos guardados
  useEffect(() => {
    const savedLastName = localStorage.getItem("familia_apellido");
    const downloaded = localStorage.getItem("familia_banner_descargado");

    if (savedLastName) {
      setLastName(savedLastName);
    }

    if (downloaded === "true") {
      setHasDownloaded(true);
    }
  }, []);

  const handleInputChange = (e) => {

    let value = e.target.value.toUpperCase();

    if (!/^[A-ZÁÉÍÓÚÑ\s]*$/.test(value)) return;

    setLastName(value);

    const parts = value.trim().split(/\s+/);

    if (parts.length > 1) {
      setError("Máximo un apellido");
      return;
    }

    if (parts[0].length > 15) {
      setError("Apellido largo");
      return;
    }

    setError("");

    localStorage.setItem("familia_apellido", value);
  };

  const handleDownload = async () => {

    if (!bannerRef.current) return;

    const element = bannerRef.current;

    const visualWidth = element.offsetWidth;

    const targetWidth = 2000;

    const scale = targetWidth / visualWidth;

    const canvas = await html2canvas(element, {
      scale,
      useCORS: true,
      backgroundColor: null,
      removeContainer: true
    });

    canvas.toBlob((blob) => {
      saveAs(blob, `familia-${lastName}.png`);
    });

    // guardar estado de descarga
    localStorage.setItem("familia_banner_descargado", "true");
    setHasDownloaded(true);
  };

  const handleShareWhatsApp = () => {

    const shareMessage = `La familia ${lastName} apoya a Darwin Sarmiento Alcalde - La Guardia.

Crea tu banner aquí:
https://noemibejaranoaparicio.com/familia`;

    const message = encodeURIComponent(shareMessage);
    const url = `https://wa.me/?text=${message}`;

    window.open(url, "_blank");
  };

  const getNameSizeClass = () => {
    if (lastName.length <= 7) return "short-name";
    return "long-name";
  };

  return (
    <div className="banner-container">

      <div className="banner-wrapper" ref={bannerRef}>
        <img src={bannerImage} alt="Banner" className="banner-image" />

        <div className={"banner-text " + (lastName.length > 9 ? "banner-text-long" : "")}>
          <div className={`banner-lastname ${getNameSizeClass()}`}>
            FAMILIA {error ? "" : lastName}
          </div>
        </div>
      </div>

      <input
        type="text"
        placeholder="Escribe tu apellido aquí"
        value={lastName}
        onChange={handleInputChange}
        className="banner-input"
      />

      {error && <div className="banner-error">{error}</div>}

      <button
        className="banner-download-button"
        onClick={handleDownload}
        disabled={!lastName || error}
      >
        Descargar Banner
      </button>

      <button
        className="banner-share-button"
        onClick={handleShareWhatsApp}
        disabled={!hasDownloaded}
      >
        Compartir en WhatsApp
      </button>

    </div>
  );
};

export default BannerWithName;